export enum AUTH_ROUTES {
  LOGIN = '/login',
  LOGOUT = '/logout',
  SESSION = '/session',
  KEEPALIVE = '/keepalive',
  DEFAULT = '/'
}

export const CIAM_PATHS = {
  // potentially need to add route here
  SESSION: '/am/json/sessions',
  REVOKE: '/am/oauth2/token/revoke'
};

export const PASSPORT_STRATEGY_NAME = 'oidc';
export enum AUTH_STRATEGY_KEYS {
  REFRESH_GRANT = 'refresh_token',
  CLIENT_ID = 'client_id',
  CLIENT_SECRET = 'client_secret',
  GRANT_TYPE = 'grant_type',
  SCOPE = 'scope',
  REDIRECT_URIS = 'redirect_uris',
  LOGOUT_REDIRECT_URIS = 'logout_redirect_uris',
  RESPONSE_TYPES = 'response_types',
  TOKEN_ENDPOINT_AUTH_METHOD = 'token_endpoint_auth_method',
  CLIENT_SECRET_POST = 'client_secret_post',
  ID_TOKEN_HINT = 'id_token_hint',
  POST_LOGOUT_REDIRECT_URI = 'post_logout_redirect_uri',
  UI_LOCALES = 'ui_locales',
  EN_REDIRECT_URI = 'en_redirect',
  FR_REDIRECT_URI = 'fr_redirect',
  EN_LOGOUT_REDIRECT_URI = 'en_logout_redirect',
  FR_LOGOUT_REDIRECT_URI = 'fr_logout_redirect',
  LOGOUT_REDIRECT_URI = 'logout_redirect_uri',
  REDIRECT_URI = 'redirect_uri',
  LOGIN_CALLBACK = 'login_callback',
  LOGOUT_CALLBACK = 'logout_callback',
  PRIVATE_PEM = 'private_pem',
  ID_TOKEN_RESPONSE_ALG = 'id_token_encrypted_response_alg',
  ID_TOKEN_ENCRYPTED_RESPONSE_ENC = 'id_token_encrypted_response_enc',
  ID_TOKEN_SIGNED_RESPONSE_ALG = 'id_token_signed_response_alg'
}

export enum DATABASE_ERROR_MESSAGES {
  DSS_ADVISOR_RETRIEVAL_ERROR = 'DSS_ADVISOR_RETRIEVAL_ERROR',
  DSS_NOT_REACHABLE = 'DSS_NOT_REACHABLE'
}

export enum ERROR_TYPES {
  UNLICENSED_ADVISOR = 'UNLICENSED_ADVISOR',
  INACTIVE_ADVISOR = 'INACTIVE_ADVISOR',
  AP_USER_NOT_FOUND = 'AP_USER_NOT_FOUND'
}

export const AUTH_HEADERS = {
  USER_REF: 'x-user-ref',
  USER_TYPE: 'x-user-type',
  SCOPE: 'scope',
  USER_CLAIMS: 'x-trip-auth',
  CIAM_ID: 'ciamid',
  LAN_ID: 'lanid',
  SALES_CHANNEL_B2B: 'b2b',
  SALES_CHANNEL_B2C: 'b2c',
  SCOPE_POLICY: 'POLICY',
  SCOPE_MAINTENANCE: 'POLICY_MAINTENANCE',
  API_USER: 'apiUser',
  API_WEBLINK: 'apiWeblink',
  ID_TOKEN: 'idToken',
  DISTRIBUTOR_ORG: 'x-distributor-org',
  DISTRIBUTOR_REF: 'x-distributor-ref',
  SELLING_CODE: 'x-user-sellingCode',
  COVERME: 'CM',
  ADVISOR_OWN_ROLE: 'Advisor_Own',
  AFFINITY_MGA_OWNER_ROLE: 'Affinity_MGA_Owner'
};

export const MIL_SECOND_FACTOR = 1000;
export const REMINDER_IN_SECONDS = 60;

export const LIA_ROLES = {
  MANAGER: 'APP-D-TravelSys-LIAmanager',
  AGENT: 'APP-D-TravelSys-LIA'
};

export const QUOTE_PERMISSIONS = {
  QUOTE_READ: 'QUOTE_READ',
  QUOTE_SAVE: 'QUOTE_SAVE'
};

export const POLICY_PERMISSIONS = {
  POLICY_CREATE: 'POLICY_CREATE',
  POLICY_READ: 'POLICY_READ',
  POLICY_UPDATE: 'POLICY_UPDATE',
  POLICY_CANCEL: 'POLICY_CANCEL',
  POLICY_BOOKING: 'POLICY_BOOKING',
  POLICY_EDIT: 'POLICY_EDIT',
  POLICY_NOTIFICATION: 'POLICY_NOTIFICATION',
  POLICY_NOTE_EDIT: 'POLICY_NOTE_EDIT',
  POLICY_NOTE_READ: 'POLICY_NOTE_READ',
  POLICY_ADMIN: 'POLICY_ADMIN',
  POLICY_QUOTE_ONLY: 'POLICY_QUOTE_ONLY'
};

export const AGENT_ADMINISTRATION_PERMISSIONS = {
  AGENT_ADMINISTRATION_READ: 'PROFILE_READ',
  AGENT_ADMINISTRATION_CREATE: 'PROFILE_CREATE',
  AGENT_ADMINISTRATION_UPDATE: 'PROFILE_EDIT',
  AGENT_ADMINISTRATION_DELETE: 'PROFILE_DELETE',
  AGENT_ADMINISTRATION_UPDATE_EXT: 'PROFILE_EDIT_EXT',
  AGENT_ORGANIZATION_READ: 'ORGANIZATION_READ',
  AGENT_ORGANIZATION_EDIT: 'ORGANIZATION_EDIT',
  AGENCY_CREATE: 'AGENCY_CREATE'
};

export const ADVISOR_ADMINISTRATION_PERMISSIONS = {
  PROFILE_ADVISOR_READ: 'PROFILE_ADVISOR_READ',
  PROFILE_ADVISOR_CREATE: 'PROFILE_ADVISOR_CREATE'
};

export const TOOLS_PERMISSIONS = {
  RATES_READ: 'RATES_READ',
  RATES_EDIT: 'RATES_EDIT'
};

export const DESTINATION_MULTIPLIER_PERMISSIONS = {
  DESTINATION_MULTIPLIER_READ: 'DESTINATION_MULTIPLIER_READ',
  DESTINATION_MULTIPLIER_EDIT: 'DESTINATION_MULTIPLIER_EDIT'
};

export const REPORT_PERMISSIONS = {
  REPORT_READ: 'REPORT_READ'
};
export const ADVISOR_REPORT_PERMISSIONS = {
  ADVISOR_REPORT: 'ADVISOR_REPORT'
};
export enum TRIPX_PERMISSIONS {
  TRIPX_SELL = 'TRIPX_SELL',
  TRIPX_READ = 'TRIPX_READ',
  TRIPX_EDIT = 'TRIPX_EDIT',
  TRIPX_DELETE = 'TRIPX_DELETE',
  TRIPX_CONFIG_EDIT = 'TRIPX_CONFIG_EDIT',
  TRIPX_NOTIFICATION = 'TRIPX_NOTIFICATION'
}

export const PAYMENT_PERMISSIONS = {
  PAYMENT_CREATE: 'PAYMENT_CREATE',
  PAYMENT_UPDATE: 'PAYMENT_UPDATE',
  PAYMENT_REFUND: 'PAYMENT_REFUND'
};

export const GRAPHAPI_PERMISSIONS = {
  GRAPH_API: 'GRAPH_API'
};

export const LICENSING_PERMISSIONS = {
  LICENSE_READ: 'LICENSE_READ',
  LICENSE_EDIT: 'LICENSE_EDIT',
  LICENSE_CREATE: 'LICENSE_CREATE'
};

export const REMERCH_PERMISSIONS = {
  REMERCH_CREATE: 'REMERCH_CREATE'
};

export const AUTH_ROLES = {
  ...QUOTE_PERMISSIONS,
  ...POLICY_PERMISSIONS,
  ...GRAPHAPI_PERMISSIONS,
  ...AGENT_ADMINISTRATION_PERMISSIONS,
  ...REPORT_PERMISSIONS,
  ...ADVISOR_REPORT_PERMISSIONS,
  ...TRIPX_PERMISSIONS,
  ...PAYMENT_PERMISSIONS,
  ...LICENSING_PERMISSIONS,
  ...TOOLS_PERMISSIONS,
  ...DESTINATION_MULTIPLIER_PERMISSIONS,
  ...ADVISOR_ADMINISTRATION_PERMISSIONS,
  ...REMERCH_PERMISSIONS
};

export enum AUTH_STRATEGY {
  AZURE_AD = 'AZURE',
  CIAM = 'CIAM'
}

export const AUTH_USER_TYPE = {
  INTERNAL_LIA: 'lanid',
  EXTERNAL_CIAM: 'ciamid'
};

export const AUTH_MAX_AGE = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
